<template>
  <div class="flex flex-wrap items-center gap-6">
    <div class="flex flex-wrap items-center gap-2">
      <div class="flex flex-wrap">
        <span v-if="isSpokaneWashington" />
        <precincts-reporting
          v-else-if="showPrecincts"
          :precincts-reporting="precinctsReporting" />
        <estimated-votes
          v-else
          :estimated-votes="data.estimated_votes"
          :precincts-reporting="precinctsReporting"
          :total-votes="totalVotes" />
      </div>

      <bar
        v-if="!isSpokaneWashington && !showPrecincts"
        :percent="percentage"
        class="bar w-20" />
    </div>
  </div>
</template>

<script>
import {
  EstimatedVotes,
  HasIncumbent,
  Logo,
  PrecinctsReporting,
  TotalVotes,
} from "@/components/standard/footer";
import Bar from "../../ui/Bar.vue";

const props = {
  data: {
    type: Object,
    required: true,
  },
  showPrecincts: {
    type: Boolean,
    required: false,
    default: false,
  },
  params: {
    type: Object,
    required: true,
  },
  lastUpdated: {
    type: String,
    required: true,
  },
};

const components = {
  EstimatedVotes,
  HasIncumbent,
  Logo,
  PrecinctsReporting,
  TotalVotes,
  Bar,
};

const computed = {
  precinctsReporting() {
    const value = this.data.precincts.percentage;
    let perc;

    if (value >= 100) {
      perc = 100;
    } else if (value > 0 && value < 1) {
      perc = "< 1";
    } else {
      perc = value.toFixed(0);
    }
    return {
      text: `${perc}% reporting`,
      perc,
    };
  },
  totalVotes() {
    return Object.values(this.data.votes).reduce((a, b) => {
      return a + b;
    });
  },
  isSpokaneWashington() {
    return this.params.raceIds === "23926";
  },
  newsmax() {
    return this.params.id === "e-cjeU" && this.params.raceIds === "25394";
  },
  percentage() {
    return this.data.estimated_votes.estimated_votes_mid === 0
      ? 0
      : (this.totalVotes / this.data.estimated_votes.estimated_votes_mid) * 100;
  },
};

export default {
  components,
  props,
  computed,
};
</script>
<style>
/* @media screen and (max-width: 520px) {
    .bar {
      display: none;
    }
  } */
</style>
